import { render, staticRenderFns } from "./InputPrice.vue?vue&type=template&id=5d7f4716&"
import script from "./InputPrice.vue?vue&type=script&lang=js&"
export * from "./InputPrice.vue?vue&type=script&lang=js&"
import style0 from "./InputPrice.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports